import { useMutation } from '@tanstack/react-query'
import { createPrescriptionFiles } from '../../../data/ordoclic/createPrescriptionFiles'
import { UserFriendlyError } from '../../../model/Error'

export type CreatePrescriptionFilesMutateVariables = Array<{
  ordoclicPatientId: string
  prescriptionIds: string[]
  medicalEventId?: number
}>

export const useCreatePrescriptionFiles = () => {
  return useMutation({
    mutationFn: async (variables: CreatePrescriptionFilesMutateVariables) => {
      const { ok, data } = await createPrescriptionFiles(variables)

      if (!ok || !data) {
        throw new UserFriendlyError(
          'error',
          "Une erreur s'est produite",
          'Impossible de générer les fichiers de la prescription',
        )
      }

      return data
    },
  })
}
